import './App.css';
import { FaDatabase } from 'react-icons/fa';

function App() {
  const formulas = [
    "E=mc²", "a²+b²=c²", "F=ma", "V=IR", "PV=nRT", "i²=-1", "∫e^x dx=e^x+C",
    "∇·E=ρ/ε₀", "∇×B=μ₀(J+ε₀∂E/∂t)", "e^(iπ)+1=0", "1+1=2", "c=λν", "F=G(m₁m₂/r²)",
    "V=IR", "pV=nRT", "E=hf", "λ=h/p", "ΔE=Δmc²", "F=q(E+v×B)", "P=W/t",
    "Q=It", "V=Ed", "C=Q/V", "R=ρL/A", "P=IV", "E=1/2mv²", "W=Fd", "T=2π√(L/g)",
    "a=Δv/Δt", "s=ut+1/2at²", "v²=u²+2as", "F=μN", "τ=rFsinθ", "L=Iω", "p=mv"
  ];

  const rainEffect = Array.from({ length: 300 }).map((_, i) => (
    <span key={i} style={{ '--i': i, '--x': Math.random() * 100 + '%', '--y': Math.random() * 100 + '%', '--duration': Math.random() * 5 + 5 + 's' }}>
      {formulas[Math.floor(Math.random() * formulas.length)]}
    </span>
  ));

  return (
    <div className="App">
      <header className="App-header">
        <div className="content">
          <FaDatabase className="database-icon" />
          <h1 className="title">World's Largest Question Database.</h1>
          <h2 className="subtitle">Free for Everyone, Everywhere.</h2>
        </div>
        <div className="background-animation">
          <div className="rain">{rainEffect}</div>
        </div>
      </header>
    </div>
  );
}

export default App;
